"use strict";
module.exports = {
    TsTablePat: require("./pat"),
    TsTableCat: require("./cat"),
    TsTablePmt: require("./pmt"),
    TsTableNit: require("./nit"),
    TsTableDsmcc: require("./dsmcc"),
    TsTableSdt: require("./sdt"),
    TsTableBat: require("./bat"),
    TsTableEit: require("./eit"),
    TsTableTdt: require("./tdt"),
    TsTableTot: require("./tot"),
    TsTableDit: require("./dit"),
    TsTableSit: require("./sit"),
    TsTableSdtt: require("./sdtt"),
    TsTableCdt: require("./cdt"),
    TsTableBit: require("./bit"),
};
//# sourceMappingURL=index.js.map